import React from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

interface Props {
  onEdit: () => void;
  onDelete?: () => void;
}

export const ActionsCell = ({ onEdit, onDelete }: Props) => (
  <Stack direction="row" spacing={1}>
    <Tooltip title="Edit Menu Template" placement="top">
      <IconButton size="small" onClick={onEdit} className="icon-btn-bordered">
        <EditIcon color="primary" />
      </IconButton>
    </Tooltip>

    {onDelete && (
      <Tooltip title="Delete Menu Template" placement="top">
        <IconButton size="small" onClick={onDelete} className="icon-btn-bordered">
          <DeleteOutlineIcon color="error" />
        </IconButton>
      </Tooltip>
    )}
  </Stack>
);
